/* eslint-disable import/prefer-default-export */
import ContentType, { ContentTypeString } from 'enums/ContentType'

export const isSocialWebLike = (type: ContentTypeString) =>
  type === ContentType.SOCIAL_WEB || type === ContentType.A3D_SUPPLEMENT
